import {t} from '../../../../common/getTranslations';
import {getFormattedNumberWithSuffix} from '../../../../common/shared/utils/getFormattedNumberWithSuffix';
import {Maybe, SaleType, TicketKind} from '../../../../graphql/generated/types';

export function getTicketRefundInfo({
  saleType,
  ticketKind,
  ticketExpireDt,
  remainCount,
  isRefundable,
}: {
  saleType: Maybe<SaleType>;
  ticketKind: Maybe<TicketKind>;
  ticketExpireDt?: Maybe<string>;
  remainCount?: number;
  isRefundable?: boolean;
}) {
  if (saleType === SaleType.Refund) {
    return t('contenthome_ticket_history_ticket_status_refunded');
  }
  if (
    ticketExpireDt &&
    new Date(ticketExpireDt).getTime() - new Date().getTime() < 0
  ) {
    return t('contenthome_ticket_history_ticket_status_expired');
  }
  if (isRefundable) {
    return t('contenthome_ticket_history_ticket_status_cancellable');
  }
  if (remainCount && remainCount > 0) {
    return t('common_ticket_amount', {
      values: {value: getFormattedNumberWithSuffix(remainCount)},
    });
  }
  if (saleType === SaleType.Sale) {
    return ticketKind === TicketKind.Own
      ? t('contenthome_ticket_history_ticket_status_used_possession')
      : t('contenthome_ticket_history_ticket_status_used_rental');
  }
}
